<form [formGroup]="form" (ngSubmit)="onSubmit(form)" class="container">
    <div>
            <div class="info">
                <div class="form1" formGroupName="data">
                    <span class="input">
                        <mat-form-field style="width: 150px;">
                            <mat-label>LMP</mat-label>
                            <input formControlName="lmp" matInput placeholder="">
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field style="width: 150px;">
                            <mat-label>G.A (LMP)</mat-label>
                            <input formControlName="ga" matInput placeholder="">
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field style="width: 150px;">
                            <mat-label>EDD (LMP)</mat-label>
                            <input formControlName="edd" matInput placeholder="">
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field style="width: 150px;">
                            <mat-label>Date</mat-label>
                            <input matInput [matDatepicker]="dob" (dateChange)="DateChange($event)">
                            <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                            <mat-datepicker #dob></mat-datepicker>
                        </mat-form-field>
                    </span>
                </div>

                <div class="img">
                    <div class="imgBox">
                        <img *ngIf="fullImage" [src]="fullImage" style="width: 100%; height: 100%;" alt="">
                    </div>
                    <div class="sel">
                         <span class="input">
                            <mat-form-field style="width: 150px;">
                            <mat-label>Images</mat-label>
                            <mat-select matNativeControl (selectionChange)="slectOnChange1($event)">
                                <mat-option *ngFor="let data of image1" [value]="data.OptionValue">{{data.OptionName}}</mat-option>
                            </mat-select>
                            </mat-form-field>
                        </span>
                        <span class="input">
                            <mat-form-field style="width: 150px;">
                            <mat-label>Images</mat-label>
                            <mat-select matNativeControl (selectionChange)="slectOnChange($event)" [disabled]="disabled">
                                <mat-option *ngFor="let data of image2" [value]="data.OptionValue">{{data.OptionName}}</mat-option>
                            </mat-select>
                            </mat-form-field>
                        </span>
                    </div>
                </div>

            </div> <br>
            <mat-divider style="margin-bottom: 30px;"></mat-divider>



            <div class="form">
                <div class="left" formGroupName="data">
                    <span class="input">
                        <mat-form-field>
                        <mat-label>No. of Fetus(es)</mat-label>
                        <input type="text" matInput formControlName="no_of_fetus" [matAutocomplete]="auto" />
                        <mat-autocomplete #auto="matAutocomplete">
                          <mat-option *ngFor="let option of NoofFetus" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field>
                        <mat-label>Technical Conditions</mat-label>
                        <input type="text" matInput formControlName="tech_cond" [matAutocomplete]="auto1" />
                        <mat-autocomplete #auto1="matAutocomplete">
                          <mat-option *ngFor="let option of TechnicalConditions" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field>
                        <mat-label>Chorionicity</mat-label>
                        <input type="text" matInput formControlName="chorionicity" [matAutocomplete]="autos" />
                        <mat-autocomplete #autos="matAutocomplete">
                          <mat-option *ngFor="let option of Chorionicity" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field>
                        <mat-label>Placenta Location</mat-label>
                        <input type="text" matInput formControlName="p_location" [matAutocomplete]="auto6" />
                        <mat-autocomplete #auto6="matAutocomplete">
                          <mat-option *ngFor="let option of PlacentaLocationAnatomic" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field>
                        <mat-label>Cervical OS</mat-label>
                        <input type="text" matInput formControlName="cervicalos" [matAutocomplete]="auto5" />
                        <mat-autocomplete #auto5="matAutocomplete">
                          <mat-option *ngFor="let option of CervicalOs" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field>
                        <mat-label>Fetal Movement</mat-label>
                        <input type="text" matInput formControlName="fetal_mment" [matAutocomplete]="autof" />
                        <mat-autocomplete #autof="matAutocomplete">
                          <mat-option *ngFor="let option of fetal_movement" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field>
                        <mat-label>Amniotic Fluid</mat-label>
                        <input type="text" matInput formControlName="a_fluid" [matAutocomplete]="auto111" />
                        <mat-autocomplete #auto111="matAutocomplete">
                          <mat-option *ngFor="let option of AmnioticFluid" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field>
                        <mat-label>Dr.</mat-label>
                        <mat-select formControlName="doctor_id" matNativeControl>
                            <mat-option *ngFor="let dr of drs" [value]="dr.id">{{dr.name}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                    </span>
                    <span class="input">
                      <mat-form-field>
                      <mat-label>Sex</mat-label>
                      <input type="text" matInput formControlName="sex" [matAutocomplete]="autol" />
                      <mat-autocomplete #autol="matAutocomplete">
                        <mat-option *ngFor="let option of gender" [value]="option.OptionValue">
                          {{option.OptionName}}
                        </mat-option>
                      </mat-autocomplete>

                      </mat-form-field>
                  </span>
                    <div class="tab">
                    <fieldset style="border: 0px;">
                        <legend>Measurement</legend>
                        <span class="input">
                            <mat-form-field>
                                <mat-label>Biperietal Diameter (MM)</mat-label>
                                <input formControlName="bd_mm" matInput placeholder="">
                            </mat-form-field>
                        </span>
                        <!-- <span class="input">
                            <mat-form-field>
                                <mat-label>Biperietal Diameter (GA)</mat-label>
                                <input formControlName="bd_ga" matInput placeholder="">
                            </mat-form-field>
                        </span> -->

                        <span class="input">
                            <mat-form-field>
                                <mat-label>Femur Diaphysics Lenght (MM)</mat-label>
                                <input formControlName="fdl_mm" matInput placeholder="">
                            </mat-form-field>
                        </span>
                        <!-- <span class="input">
                            <mat-form-field>
                                <mat-label>Femur Diaphysics Lenght (GA)</mat-label>
                                <input formControlName="fdl_ga" matInput placeholder="">
                            </mat-form-field>
                        </span> -->
                        <span class="input">
                            <mat-form-field>
                                <mat-label>Abdominal Circumfrence (MM)</mat-label>
                                <input formControlName="ac_mm" matInput placeholder="">
                            </mat-form-field>
                        </span>
                        <!-- <span class="input">
                            <mat-form-field>
                                <mat-label>Abdominal Circumfrence (GA)</mat-label>
                                <input formControlName="ac_ga" matInput placeholder="">
                            </mat-form-field>
                        </span> -->
                        <span class="input">
                            <mat-form-field>
                                <mat-label>Head Circumfrence (MM)</mat-label>
                                <input formControlName="hc_mm" matInput placeholder="">
                            </mat-form-field>
                        </span>
                        <!-- <span class="input">
                            <mat-form-field>
                                <mat-label>Head Circumfrence (GA)</mat-label>
                                <input formControlName="hc_ga" matInput placeholder="">
                            </mat-form-field>
                        </span> -->
                        <span class="input">
                            <mat-form-field>
                                <mat-label>Gestational Age(mean)</mat-label>
                                <input formControlName="g_age" matInput placeholder="">
                            </mat-form-field>
                        </span>
                        <span class="input">
                            <mat-form-field>
                                <mat-label>Estimated Fetal Weight</mat-label>
                                <input formControlName="efw" matInput placeholder="">
                            </mat-form-field>
                        </span>
                        <span class="input">
                            <mat-form-field>
                                <mat-label>Expected Delivery Date</mat-label>
                                <input formControlName="exdd" matInput placeholder="">
                            </mat-form-field>
                        </span>
                    </fieldset>
                    <fieldset class="size" style="border: 0px;">
                        <legend>Fetus</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 50px; margin-top: 40px;">Fetus:</label>
                        <mat-radio-group [(ngModel)]="fetus" (change)="changeFetus($event)" [ngModelOptions]="{standalone: true}">
                            <mat-radio-button color="primary" class="example-margin" value="A">A</mat-radio-button>
                            <mat-radio-button color="primary" class="example-margin" value="B">B</mat-radio-button>
                            <mat-radio-button color="primary" class="example-margin" value="C">C</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    </fieldset>
                    </div>
                </div>

        <div formGroupName="metric">
            <div class="right">
                <fieldset class="size">
                    <legend (click)="head()">Head</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Shape:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="head_shape_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                                <!-- <mat-radio-button color="primary" class="example-margin" value="AB">AB</mat-radio-button>
                                <mat-radio-button color="primary" class="example-margin" value="NV">NV</mat-radio-button> -->
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_shape_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                                <!-- <mat-radio-button color="primary" class="example-margin" value="AB">AB</mat-radio-button>
                                <mat-radio-button color="primary" class="example-margin" value="NV">NV</mat-radio-button> -->
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_shape_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                                <!-- <mat-radio-button color="primary" class="example-margin" value="AB">AB</mat-radio-button>
                                <mat-radio-button color="primary" class="example-margin" value="NV">NV</mat-radio-button> -->
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Cavum Ceptum Pellucidi:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="head_cavum_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_cavum_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_cavum_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Midline Falax:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="head_midline_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_midline_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_midline_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Thalamine:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="head_thalami_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_thalami_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_thalami_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Lateral Ventride:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="head_lateral_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_lateral_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_lateral_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Cerebellum:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="head_cere_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_cere_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="head_cere_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                </fieldset>

                <fieldset class="size">
                    <legend (click)="face()">Face</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Upper Lip:</label>
                            <span class="pos">
                                <mat-radio-group formControlName="face_upp_n">
                                    <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="face_upp_ab">
                                    <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="face_upp_nv">
                                    <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                                </mat-radio-group>
                            </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Orbits:</label>
                            <span class="pos">
                                <mat-radio-group formControlName="face_orbit_n">
                                    <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="face_orbit_ab">
                                    <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="face_orbit_nv">
                                    <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                                </mat-radio-group>
                            </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Nose:</label>
                            <span class="pos">
                                <mat-radio-group formControlName="face_nose_n">
                                    <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="face_nose_ab">
                                    <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="face_nose_nv">
                                    <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                                </mat-radio-group>
                            </span>
                    </div>

                </fieldset>

                <fieldset class="size">
                    <legend (click)="neck()">Neck</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Neck:</label>
                            <span class="pos">
                                <mat-radio-group formControlName="neck1">
                                    <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="neck2">
                                    <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="neck3">
                                    <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                                </mat-radio-group>
                            </span>
                    </div>
                </fieldset>

                <fieldset class="size">
                    <legend (click)="tho()">Thorax</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Shape:</label>
                            <span class="pos">
                                <mat-radio-group formControlName="tho_shape_n">
                                    <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="tho_shape_ab">
                                    <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                                </mat-radio-group>
                                <mat-radio-group formControlName="tho_shape_nv">
                                    <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                                </mat-radio-group>
                            </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">No Masses:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="tho_mass_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="tho_mass_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="tho_mass_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                </fieldset>

                <fieldset class="size">
                    <legend (click)="heart()">Heart</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Heart Activity:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="heart_activity_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_activity_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_activity_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Size:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="heart_size_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_size_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_size_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Cardiac Axis:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="heart_cadic_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_cadic_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_cadic_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Four-chamber View:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="heart_chamber_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_chamber_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="heart_chamber_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                </fieldset>

                <fieldset class="size">
                    <legend (click)="ab()">Abdomen</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Diaphgram:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="abdo_dia_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_dia_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_dia_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Stomach:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="abdo_sto_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_sto_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_sto_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Bowel:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="abdo_bowel_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_bowel_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_bowel_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Kidney:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="abdo_kidney_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_kidney_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_kidney_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Urinary Bladder:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="abdo_unary_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_unary_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_unary_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Abdomen Cord Insertion:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="abdo_insert_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_insert_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_insert_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Cord Vessels:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="abdo_vessel_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_vessel_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="abdo_vessel_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                </fieldset>

                <fieldset class="size">
                    <legend (click)="spine()">Spine</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Spine:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="spine1">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="spine2">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="spine3">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                </fieldset>

                <fieldset class="size">
                    <legend (click)="limb()">Limbs</legend>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Right arm:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="limbs_ra_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_ra_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_ra_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Right Leg:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="limbs_rl_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_rl_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_rl_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Left arm:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="limbs_la_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_la_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_la_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                    <div class="input">
                        <label class="example-margin" style="margin-left: 0; margin-right: 20px; margin-top: 40px;">Left Leg:</label>
                        <span class="pos">
                            <mat-radio-group formControlName="limbs_ll_n">
                                <mat-radio-button color="primary" class="example-margin" value="P">N</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_ll_ab">
                                <mat-radio-button color="primary" class="example-margin" value="P">AB</mat-radio-button>
                            </mat-radio-group>
                            <mat-radio-group formControlName="limbs_ll_nv">
                                <mat-radio-button color="primary" class="example-margin" value="P">NV</mat-radio-button>
                            </mat-radio-group>
                        </span>
                    </div>
                </fieldset>
                <!-- <span class="input">
                  <mat-form-field>
                  <mat-label>Gender</mat-label>
                  <mat-select formControlName="gender" matNativeControl>
                      <mat-option *ngFor="let data of gender" [value]="data.OptionValue">{{data.OptionName}}</mat-option>
                  </mat-select>
                  </mat-form-field>
              </span> -->
            </div>
        </div>
        <div class="space"></div>
        <mat-divider style="margin-bottom: 30px;"></mat-divider>
            <div class="form" formGroupName="data">
                <div class="left">
                    <span class="input">
                        <mat-form-field>
                            <mat-label>Findings (please details)</mat-label>
                            <textarea formControlName="finding" matInput></textarea>
                        </mat-form-field>
                    </span>
                </div>

                <div class="right">
                    <div class="space1"></div>
                    <span class="example">
                        <mat-checkbox style="margin: 20px;" color="primary" formControlName="conclusion1" >Normal and Completed Examination</mat-checkbox>
                    </span>
                    <div class="space1"></div>
                    <span class="example">
                        <mat-checkbox style="margin: 20px;" color="primary" formControlName="conclusion2" >Normal but Incomplete Examination</mat-checkbox>
                    </span>
                    <div class="space1"></div>
                    <span class="example">
                        <mat-checkbox style="margin: 20px;" color="primary" formControlName="conclusion3" >Abnormal Examination</mat-checkbox>
                    </span>
                </div>

            </div>

            <div class="button">
                <button (click)="add()" type="button" class="button" mat-raised-button color="primary"> Add</button>
                <a routerLink="/Result-entry" class="waves-effect">
                  <button type="button" style="margin-left: 20px;" class="button" mat-raised-button color="primary"> Cancel</button>
                </a>
                <button [disabled]="disable" type="submit" class="submit" mat-raised-button color="primary" *ngIf="!isLoading"> Save</button>
                <button [disabled]="disable" type="submit" class="button" mat-raised-button color="primary" *ngIf="isLoading"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button>
            </div>
        </div>




    </div>
</form>
